"use client";
import setupAxiosGlobally from "@config/axios.setup";

setupAxiosGlobally();

export function AxiosSetup() {
  return null;
}